import React from 'react';
import PropTypes from 'prop-types';
import {TransitionGroup} from 'react-transition-group';
import classnames from 'classnames';

import FadeTransition from './fade-transition.js';

export default class Gallery extends React.PureComponent {
    static propTypes = {
        images: PropTypes.arrayOf(PropTypes.string).isRequired,
        onClose: PropTypes.func.isRequired
    };

    state = {
        selectedImageIndex: 0,
        playing: true,
        forwardScroll: true
    };

    next = () => {
        this.setState((state) => {
            let nextIndex = state.selectedImageIndex + 1;
            if (nextIndex >= this.props.images.length) {
                nextIndex = 0;
            }

            return {
                ...state,
                selectedImageIndex: nextIndex
            };
        });
    }

    prev = () => {
        this.setState((state) => {
            let nextIndex = state.selectedImageIndex - 1;
            if (nextIndex < 0) {
                nextIndex = this.props.images.length - 1;
            }

            return {
                ...state,
                selectedImageIndex: nextIndex
            };
        });
    }

    advance = () => {
        if (this.state.forwardScroll) {
            this.next();
        } else {
            this.prev();
        }
    }

    pause = () => {
        clearInterval(this.intervalId);
        this.intervalId = null;
        this.setState({playing: false});
    };

    play = (forwardScroll) => () => {
        if (!this.intervalId) {
            this.intervalId = setInterval(this.advance, 3500);
        }

        this.setState({playing: true, forwardScroll});
    }

    componentDidMount() {
        this.play(true)();
    }

    componentWillUnmount() {
        clearInterval(this.intervalId);
    }

    renderControls() {
        let pauseClassNames = {
            control: true,
            disabled: !this.state.playing 
        };

        

        let forwardClassNames = {
            control: true,
            disabled: this.state.playing ? this.state.forwardScroll : false
        };

        let backwardClassNames = {
            control: true,
            disabled: this.state.playing ? !this.state.forwardScroll : false
        };

        return (
            <ul className="controls">
                <li key="cancel" onClick={this.props.onClose} className="control">X</li>
                <li key="forward" onClick={this.play(true)} className={classnames(forwardClassNames)}>|&gt;</li>
                <li key="backward" onClick={this.play(false)} className={classnames(backwardClassNames)}>&lt;|</li>
                <li key="pause" onClick={this.pause} className={classnames(pauseClassNames)}>||</li>
            </ul>
        );
    }

    render() {
        let selectedImage = this.props.images[this.state.selectedImageIndex];
        return (
            <div className="gallery">
                <TransitionGroup className="slides">
                    <FadeTransition key={selectedImage} duration={1500}>
                        <img className="slide-image" src={selectedImage} />
                    </FadeTransition>
                </TransitionGroup>
                <TransitionGroup className="controls-container" appear={true}>
                    <FadeTransition key="controls" fadeIn={true} duration={100}>
                        {this.renderControls()}
                    </FadeTransition>
                </TransitionGroup>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/gallery.js